var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.346191,
    y: 0.400513,
    width: 39.5893,
    height: 38.5995,
    rx: 4,
    fill: "#FF9800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2445 28.3716L32.7698 26.2139V21.1477C32.7698 19.2178 29.0088 17.1536 27.5737 16.0815",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4838 22.3964L25.8732 19.5748C25.3695 19.0836 24.5529 19.0836 24.0492 19.5748C23.5455 20.0659 23.5455 20.8621 24.0492 21.3532L27.5459 25.2006V27.6131C27.5459 28.7528 29.2166 30.5515 29.2166 30.5515",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6044 30.5564H13.3452C12.594 30.5558 11.9854 29.9619 11.9854 29.2295V10.171C11.9854 9.43855 12.594 8.84465 13.3452 8.84412H26.2117C26.9635 8.84412 27.5731 9.43802 27.5736 10.171V20.9036",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9541 26.7495H23.1194",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9541 22.7834H23.1194",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9546 24.7665H23.1199",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0522 21.8715V27.6614",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2988 19V20",
    stroke: "white",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.999 13.8634C16.999 11.3789 21.999 11.3789 21.999 13.8634C21.999 16.3478 19.3067 14.795 19.3067 16.6584C19.3067 18.5217 19.3067 17.9006 19.3067 17.9006",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuote);
export default __webpack_public_path__ + "static/media/ic-quote.8850676ec682cb14dfe83586481bae0b.svg";
export { ForwardRef as ReactComponent };